import React, { useEffect, useState } from "react";
import "./newclaim.scss";
import Navbar from "../landing/header/Navbar";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Modal, Pagination } from "react-bootstrap";
import AvailaibleClaim from "./AvailaibleClaim";
import { Link } from "react-router-dom";
import { useWeb3React } from "@web3-react/core";
import SumsubWebSdk from "@sumsub/websdk-react";
import useAuth from "../../hooks/useAuth";
import { Api_Url_Rain, Api_Url_Staging } from "../../utils/ApiUrl";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import axios from "axios";
import VestingClaimRow from "./vestingClaimRow";
import ClaimVestTokens from "../../hooks/Vestinghooks/useClaimVestTokens";
import { gql, useQuery } from "@apollo/client";
import ClaimHistory from "./claimHistory";
import useGetAirdrop from "../../hooks/Vestinghooks/useGetAirdrop";
import useAirdrops from "../../hooks/Vestinghooks/useAirdrops";
import Loader from "../../hooks/loader";
import useGetVestingInfo from "../../hooks/Vestinghooks/useGetVestingInfo";
import { ethers } from "ethers";
import { switchChain } from "../../utils/chains/switchChain";
import useSignatureLeiaClaims from "../../hooks/userSignLeiaClaims";
import useCurrentBlockNumber from "../../hooks/useCurrentBlockNumber";
import useGetCycleStartBlockNumber from "../../hooks/Vestinghooks/getCycleStartBlockNumber";
import useWeb3 from "../../hooks/useWeb3";
import { setupNetwork } from "../../utils/wallet";

const Tokenclaimdetail = () => {
  const [key, setKey] = useState("claimschedule");

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);

  const web3 = useWeb3();

  const { account, chainId } = useWeb3React();
  const { logout } = useAuth();
  const history = useHistory();
  const { userSignLeiaClaims } = useSignatureLeiaClaims();
  const airdrops = useAirdrops();
  const { claimVestTokens } = ClaimVestTokens();
  // const CurrentBlockNumber = useCurrentBlockNumber();
  // const { cycleStartBlockNum, refetchCycleStartBlockNum } =
  //   useGetCycleStartBlockNumber();

  const [loader, setLoader] = useState(false);
  const [kycLoading, setKycLoading] = useState(false);
  const [loaderMsg, setLoaderMsg] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [schedule, setSchedule] = useState(null);
  const [claimsData, setClaimsData] = useState([]);
  const [claimsTimes, setClaimsTimes] = useState([]);

  const [currentCycle, setCurrentCycle] = useState(null);

  const [totalPurchasedTokens, setTotalPurchasedTokens] = useState(null);
  const [totalClaimed, setTotalClaimed] = useState(null);
  const [totalClaimable, setTotalClaimable] = useState(null);
  const [unlockedTokens, setUnlockedTokens] = useState(null);

  const [profile, setProfile] = useState(null);

  const [isKycVer, setIsKycVer] = useState(false);
  const [startKyc, setStartKyc] = useState(false);
  const [isClaimsCompleted, setIsClaimsCompleted] = useState(false);

  const { vestingInfo, refetchVestingInfo } = useGetVestingInfo(
    account && totalPurchasedTokens
      ? ethers.utils.parseUnits(totalPurchasedTokens.toString(), 18).toString()
      : null,
    account
  );

  const addrSign = localStorage.getItem("addrSign"); 

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = schedule?.slice(indexOfFirstItem, indexOfLastItem);

  const [currentHistoryPage, setCurrentHistoryPage] = useState(1);
  const historyItemsPerPage = 10;
  const indexOfLastHistoyItem = currentHistoryPage * historyItemsPerPage;
  const indexOfFirstHistoryItem = indexOfLastHistoyItem - historyItemsPerPage;
  const currentClaimsItems = claimsData?.slice(
    indexOfFirstHistoryItem,
    indexOfLastHistoyItem
  );

  const CLAIMS = gql`
    query MyQuery($account: String!) {
      claims(
        where: { account: $account }
        orderBy: blockTimestamp
        orderDirection: desc
      ) {
        blockTimestamp
        transactionHash
        airdropped
      }
    }
  `;
  const {
    data: claimsDataGraph,
    loading: claimsLoading,
    error: claimsError,
    refetch: refetchClaimsData,
  } = useQuery(CLAIMS, {
    variables: { account: account?.toLowerCase() },
    skip: !account,
    fetchPolicy: "network-only",
  });
  useEffect(() => {
    if (claimsDataGraph && claimsDataGraph.claims.length > 0) {
      setClaimsData(claimsDataGraph.claims);
    }
  }, [claimsDataGraph]);

  const CLAIMS_TIMES = gql`
    query MyQuery($account: String!) {
      claimTimes(where: { account: $account }) {
        time
        account
      }
    }
  `;
  const {
    data: claimsTimesData,
    loading: claimTimesLoading,
    refetch: refetchClaimsTimesData,
  } = useQuery(CLAIMS_TIMES, {
    variables: { account: account?.toLowerCase() },
    skip: !account,
    fetchPolicy: "network-only",
  });
  useEffect(() => {
    console.log("claimsTimesData cccccc", claimsTimesData);
    if (claimsTimesData && claimsTimesData.claimTimes.length > 0) {
      setClaimsTimes(claimsTimesData.claimTimes[0]);
    }
  }, [claimsTimesData]);

  const updateWallet = async () => {
    if (!account) {
      const locaWallet = localStorage.getItem("connectorId");
      await logout(locaWallet);
      setClaimsData([]);
      localStorage.removeItem("connectorId");
      localStorage.removeItem("flag");
      localStorage.removeItem("dopToken");
      localStorage.removeItem("chain");
      localStorage.removeItem("fallback");
      localStorage.removeItem("walletAddress");
      history.push("/");
    }
  };

  const getProfile = async () => {
    let token = localStorage.getItem("dopToken");
    let project = localStorage.getItem("project");

    let url = Api_Url_Rain;

    setLoader(true);
    var config = {
      method: "get",
      url: `${url}/users/profile`,

      headers: {
        Authorization: "Bearer " + token,
      },
      data: {},
    };
    await axios(config)
      .then(function (res) {
        const resss = res?.data.data;
        setProfile(resss);
        setTotalPurchasedTokens(resss?.dopPurchased);
        if (resss?.kycRequired === false) {
          setIsKycVer("approved");
        } else {
          setIsKycVer(resss?.kycStatus);
        }
        setLoader(false);
      })
      .catch(function (err) {
        if (!err?.response) {
          setLoader(false);
        } else if (err?.response) {
          if (err?.response?.status === 401) {
            getSignThenCallProfile(url);
          }
        }
        console.error("errrrrrrrr", err?.response);
      });
  };

  const getSignThenCallProfile = async (url) => {
    let devicee = localStorage.getItem("device");

    try {
      setLoader(true);
      setLoaderMsg("Please sign the transaction from your wallet");

      let v = await userSignLeiaClaims();
      setLoaderMsg("");

      let config;

      if (devicee === "Safe{Wallet}") {
        config = {
          method: "post",
          url: `${url}/auth/signin/safe`,
          data: {
            walletAddress: account.toLowerCase(),
            sign: v,
          },
        };

        await axios(config)
          .then(function (res) {
            const resData = res?.data?.data;
            console.log(resData, "resData sigin");
            localStorage?.setItem("dopToken", resData?.accessToken);
            localStorage?.setItem("refreshToken", resData?.refreshToken);
            localStorage?.setItem("addrSign", account);
            localStorage?.setItem("signValue", v);
            getProfile();
          })
          .catch(function (err) {
            setLoader(false);
            throw err;
          });
      } else {
        config = {
          method: "post",
          url: `${url}/auth/signin`,
          data: {
            walletAddress: account.toLowerCase(),
            sign: v,
          },
        };
        await axios(config)
          .then(function (res) {
            const resData = res?.data?.data;
            console.log(resData, "resData sigin");
            localStorage?.setItem("dopToken", resData?.accessToken);
            localStorage?.setItem("refreshToken", resData?.refreshToken);
            localStorage?.setItem("addrSign", account);
            localStorage?.setItem("signValue", v);
            localStorage.setItem("project", "RAIN");
            getProfile();
          })
          .catch(function (err) {
            setLoader(false);
            throw err;
          });
      }
    } catch (error) {
      setLoader(false);
      history.push("/mypurchases");
    }
  };

  const callAirdrop = async (account) => {
    const res = await airdrops(account, web3);
    if (res) {
      const claimedAmountConverted = Number(res) / 10 ** 18 || 0;
      setTotalClaimed(claimedAmountConverted);
    }
  };

  const claimTokens = async () => {
    try {
      // await setupNetwork();
      let token = localStorage.getItem("dopToken");
      setLoader(true);
      setLoaderMsg("Confirm transaction from your wallet");
      const from = Number(vestingInfo.prevCycle) + 1;
      const to = currentCycle; // Assuming currentCycle is the last month to claim

      // claimMonths as array of strings, e.g., ["1", "2", "3"]
      const claimMonths = Array.from({ length: to - from + 1 }, (_, i) =>
        String(from + i)
      );

      let apiResponse = await axios.post(
        `${Api_Url_Rain}/claim/proof/vested/dynamic`,
        {
          claimMonths: claimMonths,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("claim apiResponse", apiResponse);

      const amountToNumber = ethers.utils.parseUnits(
        totalPurchasedTokens.toString(),
        18
      );

      let amount = amountToNumber.toString();
      let proof = apiResponse?.data?.data?.merkleProof;
      let random = apiResponse?.data?.data?.sign?.random;
      let deadline = apiResponse?.data?.data?.sign?.deadline;
      let signature = apiResponse?.data?.data?.sign?.signedKey;
      
      if (proof) {
        const claimRes = await claimVestTokens(
          account,
          proof,
          amount,
          random,
          deadline,
          signature,
          setLoader,
          setLoaderMsg,
          setRefresh,
          refetchClaimsData,
          refetchClaimsTimesData,
          refetchVestingInfo,
          handleShow1,
          refresh,
          handleShow2,
          callAirdrop
        );
      }
    } catch (error) {
      handleShow2();
      setLoader(false);
      setLoaderMsg("");
      console.error("Error claiming tokens:", error);
    }
  };
  console.log(chainId, "chainIddd");

  useEffect(() => {
    if (account && chainId) {
      if (chainId != 42161) {
        switchChain(42161, 3);
      } else if( addrSign !== account){
        window.location.assign("/");
      } else {
        getProfile();
        callAirdrop(account);
        // setTimeout(() => {
        //   callAirdrop(account);
        // }, 2000);
      }
    }
  }, [account, chainId, refresh]);

  const [sumStatus, setSumStatus] = useState(false);
  const [kycInit, setKycInit] = useState(false);

  const initializeKyc = async () => {
    if (sumStatus === "not_started") {
      setKycLoading(true);
      let token = localStorage.getItem("dopToken");
      var config = {
        method: "post",
        url: `${Api_Url_Rain}/kycs/init`,
        headers: {
          Authorization: "Bearer " + token,
        },
        data: {
          id: profile?._id,
          levelName: "raintokenclaims",
          ttl: "600",
        },
      };

      await axios(config)
        .then(function (res) {
          console.log("111111111res", res?.data?.data);
          setKycInit(res?.data?.data);
          setKycLoading(false);
        })
        .catch(function (err) {
          setKycLoading(false);
          throw err;
        });
    } else if (sumStatus === "pending") {
      setKycLoading(true);
      let token = localStorage.getItem("dopToken");
      var config = {
        method: "post",
        url: `${Api_Url_Rain}/kycs/access-token`,
        headers: {
          Authorization: "Bearer " + token,
        },
        data: {
          id: profile?._id,
          levelName: "raintokenclaims",
          ttl: "600",
        },
      };

      await axios(config)
        .then(function (res) {
          console.log("111111111res 2", res?.data?.data);
          setKycInit(res?.data?.data);
          setKycLoading(false);
        })
        .catch(function (err) {
          setKycLoading(false);
          throw err;
        });
    }
  };

  const accessTokenExpirationHandler = async () => {
    return await initializeKyc(); // refresh token when expired
  };

  const config = {
    levelName: "raintokenclaims",
    ttlInSecs: "600",
  };

  const options = {
    addViewportTag: false,
    adaptIframeHeight: true,
  };

  const getKycStatus = async () => {
    setKycLoading(true);
    let token = localStorage.getItem("dopToken");
    var config = {
      method: "get",
      url: `${Api_Url_Rain}/kycs/status`,

      headers: {
        Authorization: "Bearer " + token,
      },
      data: {},
    };
    await axios(config)
      .then(function (res) {
        setSumStatus(res?.data?.data?.status);
        setKycLoading(false);
      })
      .catch(function (err) {
        console.error("errrrrrrrr", err?.response);
        setKycLoading(false);
      });
  };

  const [copied, setCopied] = useState(false);

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);

      setTimeout(() => setCopied(false), 2000); // reset after 2s
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  useEffect(() => {
    if (profile && sumStatus) {
      initializeKyc();
    } else if (profile && !sumStatus) {
      getKycStatus();
    }
  }, [profile, sumStatus]);

  useEffect(() => {
    if (
      vestingInfo === null
      // && cycleStartBlockNum != null &&
      // CurrentBlockNumber &&
      // CurrentBlockNumber < cycleStartBlockNum
    ) {
      setUnlockedTokens(0);
      setTotalClaimable(0);
      // setCurrentCycle(0);
      return;
    }

    if (totalClaimed !== null && vestingInfo !== null) {
      const unlockAmountToNumber =
        Number(vestingInfo?.airdropped) / 10 ** 18 || 0;

      const claimableToNumber =
        Number(vestingInfo?.airdropped) / 10 ** 18 - totalClaimed || 0;

      if (totalClaimed >= totalPurchasedTokens) {
        setIsClaimsCompleted(true);
      }

      setUnlockedTokens(unlockAmountToNumber);
      setTotalClaimable(claimableToNumber);
      setCurrentCycle(Number(vestingInfo?.nextCycle) || 0);
    }
  }, [totalClaimed, vestingInfo]);

  // useEffect(() => {
  //   let timeoutId;
  //   if (!account) {
  //     timeoutId = setTimeout(() => {
  //       updateWallet();
  //     }, 2000);
  //   }

  //   return () => clearTimeout(timeoutId);
  // }, [account]);

  useEffect(() => {
    let schedule1 = null;
    schedule1 = [
      {
        id: 1,
        date: "2025-01-07T10:00:00Z",
        percentage: 3,
      },
      {
        id: 2,
        date: "2025-02-07T10:00:00Z",
        percentage: 4,
      },
      {
        id: 3,
        date: "2025-03-07T10:00:00Z",
        percentage: 4,
      },
      {
        id: 4,
        date: "2025-04-07T10:00:00Z",
        percentage: 4,
      },
      {
        id: 5,
        date: "2025-05-07T10:00:00Z",
        percentage: 4,
      },
      {
        id: 6,
        date: "2025-06-07T10:00:00Z",
        percentage: 5,
      },
      {
        id: 7,
        date: "2025-07-07T10:00:00Z",
        percentage: 6,
      },
      {
        id: 8,
        date: "2025-08-07T10:00:00Z",
        percentage: 7,
      },
      {
        id: 9,
        date: "2025-09-07T10:00:00Z",
        percentage: 8,
      },
      {
        id: 10,
        date: "2025-10-07T10:00:00Z",
        percentage: 9,
      },
      {
        id: 11,
        date: "2025-11-07T10:00:00Z",
        percentage: 10,
      },
      {
        id: 12,
        date: "2025-12-07T10:00:00Z",
        percentage: 11,
      },
      {
        id: 13,
        date: "2025-12-07T10:00:00Z",
        percentage: 7,
      },
      {
        id: 14,
        date: "2025-12-07T10:00:00Z",
        percentage: 7,
      },
      {
        id: 15,
        date: "2025-12-07T10:00:00Z",
        percentage: 5,
      },
      {
        id: 16,
        date: "2025-12-07T10:00:00Z",
        percentage: 3,
      },
      {
        id: 17,
        date: "2025-12-07T10:00:00Z",
        percentage: 2,
      },
      {
        id: 18,
        date: "2025-12-07T10:00:00Z",
        percentage: 1,
      },
    ];

    setSchedule(schedule1);
  }, []);

  useEffect(() => {
    if (
      !totalClaimed === null ||
      !totalClaimable === null ||
      !schedule ||
      !totalPurchasedTokens === null
    )
      return;

    const tempSchedule = schedule.map((s) => ({
      ...s,
      claimedRHS: Math.floor((s.percentage / 100) * totalPurchasedTokens),
      claimedLHS: 0,
      claimable: 0,
    }));

    if (currentCycle == null) {
      setSchedule(tempSchedule);
      return;
    }

    let remainingClaimed = totalClaimed;
    let lastClaimedCycle = null;

    // Distribute claimedLHS
    for (let i = 0; i < tempSchedule.length; i++) {
      const cycle = tempSchedule[i];

      if (i > currentCycle) {
        // after current cycle → everything is 0
        cycle.claimedLHS = 0;
        cycle.claimable = 0;
        continue;
      }

      if (remainingClaimed >= cycle.claimedRHS) {
        // fully claimed
        cycle.claimedLHS = cycle.claimedRHS;
        remainingClaimed -= cycle.claimedRHS;
      } else {
        // partially claimed, mark lastClaimedCycle
        cycle.claimedLHS = remainingClaimed;
        remainingClaimed = 0;
        lastClaimedCycle = i;
        break;
      }
    }

    // Zero out claimedLHS for later cycles
    for (
      let j = (lastClaimedCycle ?? currentCycle) + 1;
      j < tempSchedule.length;
      j++
    ) {
      tempSchedule[j].claimedLHS = 0;
    }

    // Distribute claimable using totalClaimable
    let remainingClaimable = totalClaimable;

    for (let i = 0; i < tempSchedule.length; i++) {
      const cycle = tempSchedule[i];

      if (i > currentCycle) {
        cycle.claimable = 0;
        continue;
      }

      const maxThisCycle = cycle.claimedRHS - cycle.claimedLHS;
      if (maxThisCycle <= 0) {
        cycle.claimable = 0;
        continue;
      }

      if (remainingClaimable >= maxThisCycle) {
        cycle.claimable = maxThisCycle;
        remainingClaimable -= maxThisCycle;
      } else {
        cycle.claimable = remainingClaimable;
        remainingClaimable = 0;
      }
    }

    console.log("Final Populated Schedule", tempSchedule);
    setSchedule(tempSchedule);
  }, [
    totalPurchasedTokens,
    currentCycle,
    totalClaimable,
    totalClaimed,
    account,
  ]);

  console.log(
    "cycleStartBlockNum, currentBlockNum, currentCycle, vestingInfo",
    {
      // cycleStartBlockNum,
      currentCycle,
      vestingInfo,
    }
  );

  return (
    <>
      {(loader || claimsLoading || claimTimesLoading) && (
        <Loader text={loaderMsg} />
      )}
      <Navbar />
      <section className="claimdetail">
        <div className="custom-container">
          <div className="topmain">
            <Link to="/mypurchases">
              <button className="backbtn">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M6.38016 3.95329L2.3335 7.99996L6.38016 12.0466" stroke="#05BADA" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.6668 8H2.44678" stroke="#05BADA" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                Back
              </button>
            </Link>
            <div className="topinner">
              <p className="toppara">Non-linear vesting Claim</p>
              <div className="tokenmain">
                <div className="tokenmainimg">
                  <img
                    src="/assets/presaletokens/rain.png"
                    alt="innerimg"
                    className="innerimg"
                  />
                </div>
                <p className="tokenpara">
                  RAIN{" "}
                  <span className="arbitrumbox">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="12"
                      viewBox="0 0 11 12"
                      fill="none"
                    >
                      <path
                        d="M0.431396 3.64823V8.35174C0.431396 8.64006 0.59911 8.92838 0.840316 9.07159L4.92009 11.4234C5.18391 11.5666 5.49672 11.5666 5.76054 11.4234L9.84032 9.07159C10.1041 8.92838 10.2492 8.64006 10.2492 8.35174V3.64823C10.2492 3.35991 10.0815 3.07159 9.84032 2.92838L5.75866 0.57662C5.49484 0.433404 5.18203 0.433404 4.91821 0.57662L0.838432 2.92838C0.574613 3.07159 0.431396 3.35991 0.431396 3.64823Z"
                        fill="#213147"
                      />
                      <path
                        d="M6.23929 6.91208L5.66266 8.49687C5.63816 8.54399 5.63816 8.59298 5.66266 8.64009L6.67083 11.3763L7.82221 10.7035L6.42962 6.91208C6.40701 6.81597 6.2864 6.81597 6.23929 6.91208Z"
                        fill="#12AAFF"
                      />
                      <path
                        d="M7.39061 4.22487C7.36611 4.12876 7.24739 4.12876 7.1984 4.22487L6.62177 5.80966C6.59727 5.85677 6.59727 5.90577 6.62177 5.95288L8.25368 10.4416L9.40506 9.76883L7.39061 4.22487Z"
                        fill="#12AAFF"
                      />
                      <path
                        d="M5.32726 0.744346C5.35176 0.744346 5.37437 0.744347 5.39887 0.768844L9.81407 3.31281C9.86118 3.33731 9.88568 3.38442 9.88568 3.45603V8.54397C9.88568 8.59108 9.86118 8.66457 9.81407 8.68718L5.39887 11.2312C5.37437 11.2556 5.35176 11.2557 5.32726 11.2557C5.30276 11.2557 5.28015 11.2556 5.25565 11.2312L0.840452 8.68718C0.793342 8.66269 0.768844 8.61557 0.768844 8.54397V3.45603C0.768844 3.40892 0.793342 3.33543 0.840452 3.31281L5.25565 0.768844C5.27827 0.744347 5.30276 0.744346 5.32726 0.744346ZM5.32726 0C5.15955 0 5.01445 0.0471105 4.87123 0.120603L0.45603 2.66457C0.167714 2.83229 0 3.1206 0 3.45603V8.54397C0 8.85678 0.167714 9.16771 0.45603 9.33542L4.87123 11.8794C5.01445 11.951 5.15955 12 5.32726 12C5.49498 12 5.64008 11.9529 5.78329 11.8794L10.1985 9.33542C10.4868 9.16771 10.6545 8.87939 10.6545 8.54397V3.45603C10.6545 3.14321 10.4868 2.83229 10.1985 2.66457L5.80591 0.120603C5.66269 0.048995 5.51759 0 5.34988 0H5.32726Z"
                        fill="#9DCCED"
                      />
                      <path
                        d="M2.42346 10.4397L2.8305 9.33542L3.64645 10.0082L2.87949 10.728L2.42346 10.4397Z"
                        fill="#213147"
                      />
                      <path
                        d="M4.96716 3.09608H3.83839C3.76679 3.09608 3.67068 3.1432 3.64618 3.21669L1.24731 9.79143L2.3987 10.4642L5.03877 3.2393C5.06327 3.16769 5.01427 3.09608 4.94267 3.09608H4.96716Z"
                        fill="white"
                      />
                      <path
                        d="M6.91026 3.09611H5.78149C5.70988 3.09611 5.61377 3.14323 5.58928 3.21672L2.85498 10.7035L4.00636 11.3763L6.98187 3.21672C7.00636 3.14511 6.95737 3.0735 6.88576 3.0735L6.91026 3.09611Z"
                        fill="white"
                      />
                    </svg>
                    Arbitrum
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="claimdetailinner">
            <div className="claimleft">
              <div className="lefttop">
                <img
                  src="/assets/leftshade.png"
                  alt="shadeimg"
                  className="shadeimg"
                />
                <div className="graphimg">
                  {/* <img
                    src="/assets/graphimg.png"
                    alt="innerimg"
                    className="innerimg img-fluid"
                  /> */}
                  <AvailaibleClaim
                    total={totalPurchasedTokens}
                    unlocked={unlockedTokens}
                    claimed={totalClaimed}
                  />
                  <div className="availablemain">
                    <p className="availablepara">Available to claim</p>
                    <div className="tokenmain">
                      <div className="tokenmainimg">
                        <img
                          src="/assets/presaletokens/rain.png"
                          alt="tokenimg"
                          className="tokenimg"
                        />
                      </div>
                      <p className="tokenpara">
                        {totalClaimable?.toLocaleString("en-US", {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2,
                        })}{" "}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="leftmid">
                  <div className="leftmidinner">
                    <p className="midpara">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9"
                        height="9"
                        viewBox="0 0 9 9"
                        fill="none"
                      >
                        <circle
                          cx="4.39758"
                          cy="4.71497"
                          r="4"
                          fill="#50BAD2"
                        />
                      </svg>
                      Claimed
                    </p>
                    <h6 className="midhead">
                      {totalClaimed?.toLocaleString("en-US", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      })}{" "}
                      RAIN
                    </h6>
                  </div>
                  <div className="leftmidinner">
                    <p className="midpara">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9"
                        height="9"
                        viewBox="0 0 9 9"
                        fill="none"
                      >
                        <circle cx="4.8175" cy="4.71497" r="4" fill="#30F1B6" />
                      </svg>
                      Unlocked
                    </p>
                    <h6 className="midhead">
                      {unlockedTokens?.toLocaleString("en-US", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      })}{" "}
                      RAIN
                    </h6>
                  </div>
                </div>
                {/* {isKycVer === "approved" ? ( */}
                <button
                  disabled={
                    // isKycVer !== "approved" ||
                    isClaimsCompleted === true || totalClaimable <= 0
                  }
                  onClick={handleShow}
                  style={{
                    opacity:
                      isClaimsCompleted === true || totalClaimable <= 0
                        ? 0.5
                        : 1,
                  }}
                  className="claimbtn"
                >
                  Claim
                </button>
                {/* ) : !startKyc ? (
                  <button
                    className="claimbtn"
                    disabled={kycLoading}
                    onClick={() => setStartKyc(true)}
                  >
                    Start KYC
                  </button>
                ) : (
                  !kycLoading &&
                  kycInit && (
                    <SumsubWebSdk
                      accessToken={kycInit.token}
                      expirationHandler={accessTokenExpirationHandler}
                      config={config}
                      options={options}
                      onMessage={(type, payload) =>
                        console.log("SDK Message:", type, payload)
                      }
                      onError={(err) => console.error("SDK Error:", err)}
                    />
                  )
                )} */}
                {/* </button> */}
              </div>
              <img
                src="/assets/leftgarphimg.png"
                alt="leftimg"
                className="leftimg img-fluid hide-in-light-theme"
              />
              <img
                src="/assets/leftgarphimglight.png"
                alt="leftimg"
                className="leftimg img-fluid d-none show-in-light-theme"
              />
            </div>
            <div className="claimright">
              <div className="righttop">
                <div className="topinner">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                  >
                    <path
                      d="M6 11.5H24"
                      stroke="#D1DADD"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6 18.5H24"
                      stroke="#D1DADD"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13 4.5L10 25.5"
                      stroke="#D1DADD"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20 4.5L17 25.5"
                      stroke="#D1DADD"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <div className="innerdetail">
                    <p className="detailpara">Month</p>
                    <h6 className="detailhead">
                      {currentCycle === null ? 0 : currentCycle + 1}/18
                    </h6>
                  </div>
                </div>
                <div className="topinner">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="29"
                    viewBox="0 0 30 29"
                    fill="none"
                  >
                    <path
                      d="M9.99976 16.9165C14.1419 16.9165 17.4998 13.6705 17.4998 9.66646C17.4998 5.66239 14.1419 2.41646 9.99976 2.41646C5.85762 2.41646 2.49976 5.66239 2.49976 9.66646C2.49976 13.6705 5.85762 16.9165 9.99976 16.9165Z"
                      stroke="#D1DADD"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M22.6121 12.5306C23.7937 12.9564 24.8452 13.6634 25.6692 14.5862C26.4933 15.509 27.0634 16.6177 27.3267 17.8099C27.5901 19.002 27.5382 20.2392 27.1759 21.4068C26.8136 22.5745 26.1525 23.6349 25.2538 24.4902C24.3552 25.3454 23.248 25.9678 22.0345 26.2998C20.8211 26.6318 19.5407 26.6626 18.3117 26.3895C17.0826 26.1164 15.9447 25.5481 15.0031 24.7372C14.0615 23.9263 13.3466 22.8989 12.9246 21.7502"
                      stroke="#D1DADD"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.74976 7.2498H9.99976V12.0831"
                      stroke="#D1DADD"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20.8871 16.7711L21.7621 17.629L18.2371 21.0365"
                      stroke="#D1DADD"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <div className="innerdetail">
                    <p className="detailpara">Total Purchased Tokens</p>
                    <h6 className="detailhead">
                      {totalPurchasedTokens?.toLocaleString("en-US", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      })}{" "}
                      RAIN
                    </h6>
                  </div>
                </div>
                <div className="topinner">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="29"
                    viewBox="0 0 30 29"
                    fill="none"
                  >
                    <path
                      d="M8 24.4998H22"
                      stroke="#D1DADD"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 4.49979H22"
                      stroke="#D1DADD"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20 24.4998V20.3278C19.9999 19.7974 19.7891 19.2888 19.414 18.9138L15 14.4998L10.586 18.9138C10.2109 19.2888 10.0001 19.7974 10 20.3278V24.4998"
                      stroke="#D1DADD"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10 4.49979V8.67179C10.0001 9.20218 10.2109 9.7108 10.586 10.0858L15 14.4998L19.414 10.0858C19.7891 9.7108 19.9999 9.20218 20 8.67179V4.49979"
                      stroke="#D1DADD"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <div className="innerdetail">
                    <p className="detailpara">Claim Type</p>
                    <h6 className="detailhead">Non-linear vesting </h6>
                  </div>
                </div>
              </div>
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="rightmaintabs"
              >
                <Tab eventKey="claimschedule" title="Claim Schedule">
                  <div className="mainclaimtable">
                    <table className="claimtable">
                      <thead>
                        <th>Month</th>
                        <th>Percent</th>
                        <th>Claimable</th>
                        <th>Claimed</th>
                        <th>Last Claimed</th>
                      </thead>
                      <tbody>
                        {currentItems?.map((item, index) => {
                          return (
                            <VestingClaimRow
                              view={"table"}
                              item={item}
                              index={indexOfFirstItem + index}
                              currentCycle={currentCycle}
                              claimsTimes={claimsTimes}
                            />
                          );
                        })}
                      </tbody>
                    </table>
                    <div className="paginationmain">
                      {schedule?.length > 0 ? (
                        <p className="pagepara">
                          SHOWING {indexOfFirstItem + 1}-
                          {Math.min(indexOfLastItem, schedule?.length)} OF{" "}
                          {schedule?.length}
                        </p>
                      ) : (
                        <p className="pagepara">SHOWING 0-0 OF 0</p>
                      )}
                      {schedule?.length > 0 && (
                        <Pagination>
                          <Pagination.Prev
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((prev) => prev - 1)}
                          />

                          {[
                            ...Array(
                              Math.ceil(schedule?.length / itemsPerPage)
                            ).keys(),
                          ].map((num) => (
                            <Pagination.Item
                              key={num + 1}
                              active={currentPage === num + 1}
                              onClick={() => setCurrentPage(num + 1)}
                            >
                              {num + 1}
                            </Pagination.Item>
                          ))}

                          <Pagination.Next
                            disabled={
                              currentPage ===
                              Math.ceil(schedule?.length / itemsPerPage)
                            }
                            onClick={() => setCurrentPage((prev) => prev + 1)}
                          />
                        </Pagination>
                      )}
                    </div>
                  </div>
                  <div className="mainboxes d-none">
                    {currentItems?.map((item, index) => {
                      return (
                        <VestingClaimRow
                          view={"box"}
                          item={item}
                          index={indexOfFirstItem + index}
                          currentCycle={currentCycle}
                          claimsTimes={claimsTimes}
                        />
                      );
                    })}
                    <div className="paginationmain">
                      {schedule?.length > 0 && (
                        <Pagination>
                          <Pagination.Prev
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((prev) => prev - 1)}
                          />

                          {[
                            ...Array(
                              Math.ceil(schedule?.length / itemsPerPage)
                            ).keys(),
                          ].map((num) => (
                            <Pagination.Item
                              key={num + 1}
                              active={currentPage === num + 1}
                              onClick={() => setCurrentPage(num + 1)}
                            >
                              {num + 1}
                            </Pagination.Item>
                          ))}

                          <Pagination.Next
                            disabled={
                              currentPage ===
                              Math.ceil(schedule?.length / itemsPerPage)
                            }
                            onClick={() => setCurrentPage((prev) => prev + 1)}
                          />
                        </Pagination>
                      )}
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="claimhistory" title="Claim History">
                  <div className="mainclaimtable">
                    <table className="claimtable">
                      <thead>
                        <th>TIME</th>
                        <th>amount</th>
                        <th>hash</th>
                      </thead>
                      <ClaimHistory
                        claimsData={claimsData}
                        currentClaimsItems={currentClaimsItems}
                        view={"table"}
                      />
                    </table>
                    <div className="paginationmain">
                      {claimsData.length > 0 ? (
                        <p className="pagepara">
                          SHOWING {indexOfFirstHistoryItem + 1}-
                          {Math.min(indexOfLastHistoyItem, claimsData?.length)}{" "}
                          OF {claimsData?.length}
                        </p>
                      ) : (
                        <p className="pagepara">SHOWING 0-0 OF 0</p>
                      )}
                      {claimsData.length > 0 && (
                        <Pagination>
                          <Pagination.Prev
                            disabled={currentHistoryPage === 1}
                            onClick={() =>
                              setCurrentHistoryPage((prev) => prev - 1)
                            }
                          />

                          {[
                            ...Array(
                              Math.ceil(
                                claimsData?.length / historyItemsPerPage
                              )
                            ).keys(),
                          ].map((num) => (
                            <Pagination.Item
                              key={num + 1}
                              active={currentHistoryPage === num + 1}
                              onClick={() => setCurrentHistoryPage(num + 1)}
                            >
                              {num + 1}
                            </Pagination.Item>
                          ))}

                          <Pagination.Next
                            disabled={
                              currentHistoryPage ===
                              Math.ceil(
                                claimsData?.length / historyItemsPerPage
                              )
                            }
                            onClick={() =>
                              setCurrentHistoryPage((prev) => prev + 1)
                            }
                          />
                        </Pagination>
                      )}
                    </div>
                  </div>
                  <div className="mainboxes d-none">
                    <ClaimHistory
                      claimsData={claimsData}
                      currentClaimsItems={currentClaimsItems}
                      view={"box"}
                    />
                    <div className="paginationmain">
                      {claimsData.length > 0 && (
                        <Pagination>
                          <Pagination.Prev
                            disabled={currentHistoryPage === 1}
                            onClick={() =>
                              setCurrentHistoryPage((prev) => prev - 1)
                            }
                          />

                          {[
                            ...Array(
                              Math.ceil(
                                claimsData?.length / historyItemsPerPage
                              )
                            ).keys(),
                          ].map((num) => (
                            <Pagination.Item
                              key={num + 1}
                              active={currentHistoryPage === num + 1}
                              onClick={() => setCurrentHistoryPage(num + 1)}
                            >
                              {num + 1}
                            </Pagination.Item>
                          ))}

                          <Pagination.Next
                            disabled={
                              currentHistoryPage ===
                              Math.ceil(
                                claimsData?.length / historyItemsPerPage
                              )
                            }
                            onClick={() =>
                              setCurrentHistoryPage((prev) => prev + 1)
                            }
                          />
                        </Pagination>
                      )}
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </section>

      <Modal
        className="common-modal-style followusonx-modal verificationemail-modal getnotified-modal"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Claim</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="verification-modal">
            <div className="claim-box">
              {/* <img
                src="\assets\modalbgshade.png"
                alt="img"
                className="img-fluid modalbgshade"
              /> */}
              <p>Claimable Tokens</p>
              <h4>
                {totalClaimable?.toLocaleString("en-US", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                })}{" "}
                RAIN
              </h4>
            </div>
            <div className="twice-btnsss">
              <button
                className="btn-cancel sscscscscscsc"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                className="btn-green sscscscscscsc"
                onClick={() => {
                  handleClose();
                  claimTokens();
                }}
              >
                Claim
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* 
      <Modal
        className="common-modal-style success-modal"
        show={true}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Claimed Successfully</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-5">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="88"
            height="88"
            viewBox="0 0 88 88"
            fill="none"
          >
            <path
              d="M76.583 37.9845L76.583 11.417L35.1296 51.7939L10.417 34.7697L10.417 59.3998L35.1296 77.583L76.583 37.9845Z"
              fill="#D1DADD"
            />
          </svg>
          <h6>
            Your claim has been <br /> processed successfully.
          </h6>
          <p></p>
          <button className="confirm-btn" onClick={handleClose1}>
            Okay
          </button>
        </Modal.Body>
      </Modal> */}

      <Modal
        className="common-modal-style success-modal"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-5">
         <img src="\assets\videos\cross.svg"/>
          <h6 className="text-center">
            Oops, something went <br /> wrong.
          </h6>
          <p></p>
          <button
            className="confirm-btn"
            onClick={handleClose2}
            style={{
              background: "#05BADA",
              color: "var(--text-color)",
            }}
          >
            CLOSE
          </button>
        </Modal.Body>
      </Modal>

      <Modal
        className="common-modal-style success-modal"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Claimed Successfully</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-5">
          <img src="\assets\videos\tcik.svg"/>
          <h6>
            Your claim has been <br /> processed successfully.
          </h6>
          <div className="addraintoken">
            <div className="upper-heading">
              <h6>Add RAIN Token to Your Wallet</h6>
              <p>Want to see your RAIN tokens in your wallet?</p>
            </div>
            <div className="address">
              <p>Just import them using this contract address:</p>
              <div className="copy-text">
                <h6>0x25118290e6A5f4139381D072181157035864099d</h6>
                <a
                  onClick={() => {
                    handleCopy("0x25118290e6A5f4139381D072181157035864099d");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_1284_6401)">
                      <path
                        d="M13.333 5.33301H6.66634C5.92996 5.33301 5.33301 5.92996 5.33301 6.66634V13.333C5.33301 14.0694 5.92996 14.6663 6.66634 14.6663H13.333C14.0694 14.6663 14.6663 14.0694 14.6663 13.333V6.66634C14.6663 5.92996 14.0694 5.33301 13.333 5.33301Z"
                        stroke="#05BADA"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2.66634 10.6663C1.93301 10.6663 1.33301 10.0663 1.33301 9.33301V2.66634C1.33301 1.93301 1.93301 1.33301 2.66634 1.33301H9.33301C10.0663 1.33301 10.6663 1.93301 10.6663 2.66634"
                        stroke="#05BADA"
                        stroke-width="1.5"
                        stroke-linecap="square"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1284_6401">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <button className="confirm-btn" onClick={handleClose1}>
            Okay
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Tokenclaimdetail;
